import React, { useState } from 'react';
import style from "./calendar.module.css";
import { DateRange, RangeKeyDict } from 'react-date-range';
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';
import { Button } from '@mui/material';

type DateRangeState = {
  startDate: Date;
  endDate: Date;
  key: string;
};

type CalendarioProps = {
    onDateChange: (startDate: Date, endDate: Date) => void;
    onCancel: () => void;  // Adicione isso para o cancelamento
};

export function Calendario({ onDateChange, onCancel }: CalendarioProps) {
  const [state, setState] = useState<DateRangeState[]>([
    {
      startDate: new Date(),
      endDate: new Date(),
      key: 'selection'
    }
  ]);

  const handleSelect = (ranges: RangeKeyDict) => {
    const { selection } = ranges;
    const newStartDate = selection.startDate || new Date();
    const newEndDate = selection.endDate || new Date();
    setState([{
      startDate: newStartDate,
      endDate: newEndDate,
      key: selection.key || 'defaultKey'
    }]);
  };

  const handleConfirm = () => {
    const { startDate, endDate } = state[0];
    onDateChange(startDate, endDate);
  };

  const handleCancel = () => {
    onCancel();  // Reseta a seleção ao cancelar
  };

  return (
    <div className={style.calendar}>
      <DateRange
        editableDateInputs={true}
        onChange={handleSelect}
        moveRangeOnFirstSelection={false}
        ranges={state}
        months={1}
        direction="horizontal"
      />
      <div className={style.buttonsContainer}>
        <Button  onClick={handleCancel} className={style.buttonsOptionLeft}>
          Cancelar
        </Button>
        <Button  onClick={handleConfirm} className={style.buttonsOptionReight}>
          Confirmar
        </Button>
      </div>
    </div>
  );
}
